module.exports = __webpack_public_path__ + "static/media/48406249_2308775195864325_9088966296661393408_o.6f7e1e15.jpg";